// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"f4a67d74","213":"418d31ae","453":"7fa0d74a","732":"afe1cc1e"}[chunkId] + ".chunk.js";
};